import { Table } from "@mantine/core";
import moment from "moment";
import { formatNumber, getInitials } from "../utils";

export const RecentPostTable = ({ data = [], theme }) => {
  const rows = (Array.isArray(data) ? data : []).filter(Boolean);

  return (
    <Table highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Post Title</Table.Th>
          <Table.Th>Views</Table.Th>
          <Table.Th>Post Date</Table.Th>
        </Table.Tr>
      </Table.Thead>

      {rows.length === 0 && <Table.Caption>No Data Found.</Table.Caption>}

      <Table.Tbody>
        {rows.map((el, idx) => (
          <Table.Tr
            key={el?._id || idx}
            className={theme ? "text-gray-400" : "text-slate-600"}
          >
            <Table.Td className="flex gap-2 items-center">
              <img
                src={el?.img || "/avatar-fallback.png"}
                alt={el?.title || "Post"}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <p className="text-base">{el?.title ?? "Untitled"}</p>
                <span className="text-[10px] text-rose-600">{el?.cat ?? "—"}</span>
              </div>
            </Table.Td>
            <Table.Td>{formatNumber(el?.views?.length ?? 0)}</Table.Td>
            <Table.Td>{el?.createdAt ? moment(el.createdAt).fromNow() : "—"}</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};

export const RecentFollowersTable = ({ data = [], theme }) => {
  const rows = (Array.isArray(data) ? data : []).filter(Boolean);

  return (
    <Table highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Follower</Table.Th>
          <Table.Th>Join Date</Table.Th>
        </Table.Tr>
      </Table.Thead>

      {rows.length === 0 && <Table.Caption>No Data Found.</Table.Caption>}

      <Table.Tbody>
        {rows.map(({ _id, createdAt, followerId: follower } = {}, idx) => {
          const name = follower?.name ?? "Unknown";
          const avatar = follower?.image;
          const accountType = follower?.accountType ?? "—";
          const followerCount = follower?.followers?.length ?? 0;

          return (
            <Table.Tr
              key={_id || idx}
              className={theme ? "text-gray-400" : "text-slate-600"}
            >
              <Table.Td className="flex gap-2 items-center">
                {avatar ? (
                  <img
                    src={avatar}
                    alt={name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                ) : (
                  <p className="w-10 h-10 rounded-full flex justify-center items-center bg-indigo-700 text-white">
                    {getInitials(name)}
                  </p>
                )}
                <div>
                  <p className="text-base">{name}</p>
                  <div className="flex gap-3 items-center">
                    <span className="text-xs text-rose-600">{accountType}</span>
                    {followerCount > 0 && (
                      <span className="text-sm text-slate-600 font-bold">
                        {formatNumber(followerCount)}
                      </span>
                    )}
                  </div>
                </div>
              </Table.Td>
              <Table.Td>{createdAt ? moment(createdAt).fromNow() : "—"}</Table.Td>
            </Table.Tr>
          );
        })}
      </Table.Tbody>
    </Table>
  );
};
